import { useState, useRef } from 'react';
import { useTranslation } from "react-i18next";
import axios from 'axios';
import HeaderHelmet from '../ui/HeaderHelmet';

const Subscribe = () => {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const emailRef = useRef(null);
    const emailIn = useRef(null);

    const validateEmail = (e) => {
        const value = e.target.value;
        if (/\S+@\S+\.\S+/.test(value)) {
            setEmail(value);
            emailRef.current.classList.remove('empty', 'incorrect');
        } else {
            setEmail('');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        let hasError = false;

        if (email.length === 0) {
            emailRef.current.classList.add('empty');
            emailRef.current.classList.remove('incorrect');
            hasError = true;
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            emailRef.current.classList.add('incorrect');
            emailRef.current.classList.remove('empty');
            hasError = true;
        } else {
            emailRef.current.classList.remove('empty', 'incorrect');
        }

        if (hasError) {
            return;
        }

        setIsSubmitting(true);

        try {
            const formData = new FormData();
            formData.append('email', email);

            if (document.querySelector('#cf-chl-widget-subscribe_response')) {
                formData.append('cf-turnstile-response', document.querySelector('#cf-chl-widget-subscribe_response').value);
            }

            await axios.post('https://admin.lestro.com/api/subscribe', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            setIsSuccess(true);
            setEmail('');
            emailIn.current.value = '';

            setTimeout(() => {
                setIsSuccess(false);
            }, 3000);
        } catch (error) {
            console.error('Subscribe error:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <HeaderHelmet
                title={t('subscribeTitle')}
                description={t('subscribeDescription')}
            />
            <section className="subscribe-page">
                <div className="container">
                    <div className="subscribe-wrapper">
                        <h1 className="subscribe-title">{t('subscribeTitle')}</h1>

                        <form onSubmit={handleSubmit} className="subscribe-form">
                            <div className='iw' ref={emailRef}>
                                <input
                                    ref={emailIn}
                                    type='text'
                                    name='email'
                                    placeholder="Email"
                                    onChange={validateEmail}
                                    disabled={isSubmitting}
                                />
                                <div className='err empty'>{t('errorEmpty')}</div>
                                <div className='err incorrect'>{t('errorIncorrectMail')}</div>
                            </div>

                            <div className="cf-turnstile" data-sitekey="0x4AAAAAAASd2q0NcDEN2yJH"></div>

                            <button
                                type="submit"
                                className="btn-send"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? t('sending') : t('send')}
                            </button>
                        </form>

                        {isSuccess && (
                            <div className="success-message">
                                {t('subscribeSuccess')}
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};

export default Subscribe;
